import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';

export class CustomValidator {
  noWhiteSpace(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    };
  }

  valoreMinoreUgualeValidator(group: FormGroup): ValidationErrors | null {
    const votazioneControl = group.get('votazione');
    const votazione = votazioneControl?.value?.split('/')[0]?.trim();
    const massimoVotazione = votazioneControl?.value?.split('/')[1]?.trim();

    if (votazione && massimoVotazione) {

      if (!isNaN(votazione) && !isNaN(massimoVotazione)) {
        const valoreControl1 = +votazione; // Converti il valore in un numero
        const valoreControl2 = +massimoVotazione;

        // Verifica se il valore del primo controllo è maggiore del secondo
        if (valoreControl1 == 0 || valoreControl1 > valoreControl2) {
          // Restituisci un errore se la condizione non è soddisfatta
          return { 'valoreMinoreUguale': true };
        }
      }
    }
    return null;
  }

  atLeastOneCheckboxCheckedValidator(group: FormGroup): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const controls = group.controls;
      const checked = Object.keys(controls).some(key => controls[key].value);
      return checked ? null : { 'atLeastOneCheckboxChecked': true };
    };
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      let invalid = false;
      const value = control.value;
      if (value) {
        const year = value?.year();
        if (year < 1900 || year > new Date().getFullYear()) {
          invalid = true;
        }
      }
      return invalid ? {'dateInvalid': true} : null;
    };
  }

}
